function number_format(number, decimals, dec_point, thousands_sep) {
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

function healShopName(str, blur) {
    str = str
        .toLowerCase()
        .replace(/[áÁ]/g, 'a')
        .replace(/[éÉ]/g, 'e')
        .replace(/[íÍ]/g, 'i')
        .replace(/[óÓöÖőŐ]/g, 'o')
        .replace(/[úÚüÜűŰ]/g, 'u')
        .replace(/-/g, '')
        .replace(/[^a-zA-Z0-9]/g, '')
    ;
    if (blur) {
        str = str.replace(/^-/g, '');
    }
    return str;
}

function backTopButton(animationTime) {
    var $element = $("#back-top");
    $element.hide();
    $(window).scroll(function () {
        if ($(this).scrollTop() > 200) {
            $("#back-top").fadeIn();
        } else {
            $("#back-top").fadeOut();
        }
    });

    $element.find('a:first').click(function () {
        $("body,html").animate({scrollTop: 0}, animationTime);
        return false;
    });
}

function backBottomButton(animationTime) {
    var $element = $("#back-bottom");
    $(window).scroll(function () {
        if ($(this).scrollTop() > 500) {
            $("#back-bottom").fadeOut();
        } else {
            $("#back-bottom").fadeIn();
        }
    });

    $element.find('a:first').click(function () {
        $("body,html").animate({scrollTop: 800}, animationTime);
        return false;
    });
}

/* SR csomagok összehasonlító táblázatában a paraméterek összehasonlítása */
function packageToggler(methodName){
    var $toggler = $(".toggler");
    var ajaxMethod = "ajax/" + methodName + ".php";
    $toggler.click(function () {
        var self = $(this);
        var ldiv = self.next();
        var modkek = self.find('.modul_kek');

        if (ldiv.css('display') == 'none' && ldiv.text() == "") {
            modkek.addClass("indicator");
            ldiv.load(ajaxMethod, {
                mid: self.data('attribute-id')
            }, function () {
                self.toggleClass('active');
                ldiv.slideToggle("slow");
                modkek.removeClass("indicator");
            });
        } else {
            self.toggleClass('active');
            ldiv.slideToggle("slow");
        }
    });
}

$(document).ready(function () {
    
    $('a[href*=#]:not(.accordion-toggle)').click(function () {
        if ($(this).parent().hasClass('scrollable_navigation') || $(this).attr('href').indexOf('javascript') > -1) return;
        var hash = this.hash.split('#');
        this.hash = hash[hash.length - 1];
        if (this.hash != '' && window.location.href.replace(window.location.hash, '') + this.hash == this) {
            var target = $(this.hash).offset().top;
            if (target > $(document).height() - $(window).height()) {
                target = $(document).height() - $(window).height();
            }

            $('html:not(:animated), body:not(:animated)').animate({scrollTop: target}, 500, 'linear');
            return false;
        }
    });

    // sticky heading start
    var distance = 60;

    function activateSticky() {
        $(".sticky-head").addClass('sticky-head-active');
    }

    function deactivateSticky() {
        $(".sticky-head").removeClass('sticky-head-active');
    }

    if ($(document).scrollTop() > distance) {
        activateSticky();
    } else {
        deactivateSticky();
    }
    $(function () {
        $(window).scroll(function () {
            if ($(this).scrollTop() > distance) {
                activateSticky();
            } else {
                deactivateSticky();
            }
        });
    });
    // sticky heading end

    backTopButton(800); // oldal tetejére ugrás
    backBottomButton(800); // lefele ugrás

});
